function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.75 4.45a.8.8 0 100 1.6h9a2.2 2.2 0 110 4.4h-9a4.55 4.55 0 000 9.1h9.056a3.051 3.051 0 005.994-.8 3.05 3.05 0 00-5.994-.8H6.75a2.95 2.95 0 010-5.9h9a3.8 3.8 0 000-7.6zm10.55 14.3a1.45 1.45 0 102.9 0 1.45 1.45 0 00-2.9 0z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgPath;